import dayjs from 'dayjs';
import aqilaApi from './aqila-api';

type ContratoResponse = {
  dataVencimentoContrato: string;
  diasParaBloqueio: number;
};

export type ContratoAlertas = {
  mensagens: string[];
  daysRemaining: number;
  daysToBlock: number;
};

class Contrato {
  async alertas(): Promise<ContratoAlertas> {
    const [{ data: contrato }, { data: mensagens }] = await Promise.all([
      aqilaApi.get<ContratoResponse>('v1/gpa'),
      aqilaApi.get<string[]>('v1/gpa/mensagens'),
    ]);

    return {
      mensagens,
      daysRemaining: dayjs(contrato.dataVencimentoContrato).diff(
        dayjs().startOf('day'),
        'day',
      ),
      daysToBlock: contrato.diasParaBloqueio,
    };
  }
}

export default new Contrato();
